import { Radio } from 'antd'
import { type ProcedureItem } from 'features/Procedure/state/procedure-api.type'
import { useCallback } from 'react'

import styles from './procedure-select.module.scss'
import { useProcedureActions } from 'features/Procedure/hooks/useProcedureActions'
import { useAppSelector } from 'common/hooks/redux'
import { useDiagnosisFormat } from 'features/Procedure/hooks/useDiagnosisFormat'

type Props = {
  procedure: ProcedureItem
  index: number
  onEditProcedure?: (procedure: ProcedureItem) => void
}

export const ProcedureSelect = ({ procedure, index, onEditProcedure }: Props) => {
  const { handleSetSelectedProcedure } = useProcedureActions()

  const { diagnosisFormat } = useDiagnosisFormat({ justifyCodes: procedure?.justify_codes })

  const isSelected = useAppSelector(
    (state) => state.procedureReducer.selectedProcedure?.id === procedure.id,
  )
  const handleChange = useCallback(() => {
    handleSetSelectedProcedure(procedure)
  }, [handleSetSelectedProcedure, procedure])

  return (
    <div className={styles.container} onClick={handleChange}>
      <span className={styles.number}>{index + 1}</span>
      <Radio value={procedure.id} className='center' checked={isSelected} />
      <div
        className={styles.diagnosisLink}
        onClick={(e) => {
          e.stopPropagation()
          onEditProcedure?.(procedure)
        }}>
        {diagnosisFormat.join(',')}
      </div>
    </div>
  )
}
